import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { createInstance, HackleProvider } from '@hackler/react-sdk';
import { NaverSDK } from './pages/login/components/Naver';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const keyHackleBrowserDev = 'WNyuIcfw3qAPgAX0yKWpjoRWcOianpQe';
const keyHackleBrowserProd = 'USrUf4OSUnmfwfGrILsS7m8TtCy7YPoa';

const client = createInstance(process.env.NODE_ENV === 'development' ? keyHackleBrowserDev : keyHackleBrowserProd, {
  debug: false,
  auto_track_page_view: true,
});

declare global {
  interface Window {
    daum: any;
    kakao?: {
      maps?: any;
    };
    naver: NaverSDK;
  }
}

root.render(
  <HackleProvider hackleClient={client}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HackleProvider>,
);
